import * as React from 'react'
import { CreateAgreementFormPacketModel } from '@user/components/Agreements/AgreementFormPacketDialog/typings'
import { useFormikContext } from 'formik'
import { ENTITY_TYPES } from '@sales-center/common'
import {
  useDragData,
  DraggableItemWrapper,
  DropResult,
} from '@user/utils/Draggable'
import Box from '@mui/material/Box'
import { DraggableAgreementCard } from './DraggableAgreementCard'
import { DraggableAttachmentCard } from './DraggableAttachmentCard'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  onDragEnd: (result: DropResult) => void
  openServicesDrawer: () => void
}

export function DraggableAgreementList(props: Props) {
  const { onDragEnd, entityId, entityType, openServicesDrawer } = props
  const { values } = useFormikContext<CreateAgreementFormPacketModel>()
  const { templates } = values

  const { containerRef, itemRefs, draggingIndex, offsets } = useDragData({
    dataList: templates,
    onDragEnd,
  })

  return (
    <>
      <Box id={'templates'} ref={containerRef}>
        {templates.map((row, i) => {
          if ('templateId' in row) {
            return (
              <DraggableItemWrapper
                key={i}
                ref={(el) =>
                  (itemRefs.current[i] = el as HTMLDivElement | null)
                }
                draggingIndex={draggingIndex}
                index={i}
                offsets={offsets}
                itemHeight="fit"
              >
                <DraggableAgreementCard
                  agreement={row}
                  index={i}
                  entityId={entityId}
                  entityType={entityType}
                  openServicesDrawer={openServicesDrawer}
                />
              </DraggableItemWrapper>
            )
          }
          if ('id' in row) {
            return (
              <DraggableItemWrapper
                key={i}
                ref={(el) =>
                  (itemRefs.current[i] = el as HTMLDivElement | null)
                }
                draggingIndex={draggingIndex}
                index={i}
                offsets={offsets}
                itemHeight="fit"
              >
                <DraggableAttachmentCard attachment={row} index={i} />
              </DraggableItemWrapper>
            )
          }
        })}
      </Box>
    </>
  )
}
